import { render, staticRenderFns } from "./AddressRelbase.vue?vue&type=template&id=70e428c2&scoped=true&"
import script from "./AddressRelbase.vue?vue&type=script&lang=js&"
export * from "./AddressRelbase.vue?vue&type=script&lang=js&"
import style0 from "./AddressRelbase.vue?vue&type=style&index=0&id=70e428c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e428c2",
  null
  
)

export default component.exports